/*
 * Copyright (c) 2022
 *
 * Created Date: Tuesday, September 27th 2022, 6:38:39 pm
 * Author: Muhammad Fajariansyah Ismail
 *
 */

import { HOME_CHAPTERS_PREFIX, HOME_COURSES_PREFIX } from "routes/RoutePrefix";

const RouteConstant = {
  auth: "",
  chooseProfile: "choose-profile",
  appRedirect: "app-redirect",
  app: {
    index: "",

    report: {
      course: "report/course",
      certification: "report/certification",
    },

    article: "article",
    assessmentTest: "assessment-test",
    calendarEvent: "calendar-event",
    certification: "certification",
    chapterTest: "chapter-test",
    eventList: "event-list",
    eventListSchedule: (id) => `event-schedule/${id}`,
    eventListScheduleRegistered: (id, batch) => `event-schedule/${id}/${batch}/registered`,
    eventListScheduleRegisteredAutoScan: (id, batch, idSchedule) => `event-schedule/${id}/${batch}/registered/scan/${idSchedule}`,
    offlineCourseAutoScan: (id, batch, idSchedule) => `course/offline-scan/${id}/${batch}/${idSchedule}`,
    feedback: "feedback",
    homeAdmin: "home-admin",
    homeEmployee: "home-employee",
    learning: "learning",
    media: (id) => `media/${id}`,
    myLearning: "mylearning",
    preTest: "pre-test",
    quizTest: "quiz-test",
    setting: "setting",
    weblink: "weblink",
    other: "other",
    addMatter: "addmatter",
    myProfile: "myprofile",
    employeeOnHighlight: "employee-on-highlight",
    trainersOnHighlight: "trainers-on-highlight",
    inbox: {
      index: "inbox",
      detail: "inbox/detail"
    },
    doSmileCertificationTest: `dosmilecertification-test`,
    doSmileCertificationDetail: `certification-detail`,
    doSmileCertificationTestWithId: (idSmile) => `dosmilecertification-test/${idSmile}`,
    doSmileCertificationDetailWithId: (idSmile) => `certification-detail/${idSmile}`,

    courses: {
      index: HOME_COURSES_PREFIX,
      chapter: (idCourse) => HOME_COURSES_PREFIX + `/${idCourse}`,
      chapterDetail: (idChapter) =>
        HOME_CHAPTERS_PREFIX + `/${idChapter}`,
    },
    dcl: {
      index: 'dcl',
      view: (dclId) => `dcl/view/${dclId}`
    }
  },
};

export default RouteConstant;
